import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NavbarComp from '../components/NavbarComp';
import { Container } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

const mapStateToProps = (state) => {
  return {
    baseline: state.baseline
  }
}

const mapDispatchToProps = dispatch => ({

});


const NavigateOnStateChange = ({ shouldNavigate, to }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (shouldNavigate) {
      navigate(to);
    }
  }, [shouldNavigate, navigate, to]);

  return null;
};

class AlertnessTestComplete extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      shouldNavigate: false,
      path: null
    };

  }
  componentDidMount() {
    if(this.props.baseline.step!==2) {
      this.setState({
        shouldNavigate: true,
        path: "/alertness"
      })
    }
  }

  render() {
    return <Fragment>
      <div className="color-body">
        <NavbarComp bgblue={true} access_token={true}/>
        <div className="page-sections">
          <div className='register-confirm-wrap'>
            <Container>
              <div className='register-confirm-contents'>
                <h2 className='main-title-style'>THANK YOU</h2>
                <p>Please complete your second test now.</p>
                <a href='/alertness-test' rel="nofollow"><button>START</button></a>
              </div>
            </Container>
          </div>
        </div>
      </div>
      <NavigateOnStateChange shouldNavigate={this.state.shouldNavigate} to={this.state.path} />
    </Fragment>
  }
}

AlertnessTestComplete.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertnessTestComplete);
